import React, { useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { useNotify } from '../../context/NotificationContext';
import { ButtonSpinner } from '../common/Loader';
import { parseError } from '../../utils/errors';

export const Blacklist = () => {
  const { adminW } = useContracts();
  const notify = useNotify();

  const [userId, setUserId] = useState('');
  const [busy, setBusy] = useState(null);

  const run = async (label, status) => {
    if (!userId) { notify.error('Enter a user ID'); return; }
    setBusy(label);
    try {
      const tx = await adminW.blacklistUser(userId, status);
      notify.info('Submitted...');
      await tx.wait();
      notify.success(status ? 'User blacklisted' : 'User un-blacklisted');
    } catch (e) {
      notify.error(parseError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="card">
      <div className="section-title">Blacklist Management</div>
      <div className="input-group">
        <label className="input-label">User ID</label>
        <input className="input" type="number" placeholder="e.g. 12345" value={userId} onChange={(e) => setUserId(e.target.value)} />
      </div>
      <div className="flex">
        <button className="btn btn-danger" disabled={busy === 'bl'} onClick={() => run('bl', true)}>
          {busy === 'bl' && <ButtonSpinner />}Blacklist
        </button>
        <button className="btn btn-secondary" disabled={busy === 'ubl'} onClick={() => run('ubl', false)}>
          {busy === 'ubl' && <ButtonSpinner />}Remove
        </button>
      </div>
    </div>
  );
};
